import { isStaffLanguage, type StaffLanguage } from '../staffText'
import type { Identity } from '../types'

/**
 * The staff screens' language. English while the UI is English only (the top-bar
 * menu hidden); otherwise the person's own choice, the organisation's staff
 * default (languages.staff), the server's answer, English. A language without a
 * shipped file is skipped.
 */
export function staffLanguageOf(
  identity: Pick<Identity, 'staff' | 'language' | 'languages'> | null,
  beforeSignIn: StaffLanguage,
  englishOnly: boolean,
): StaffLanguage {
  if (englishOnly) return 'en'
  if (!identity) return beforeSignIn
  for (const lang of [identity.staff.language, identity.languages?.staff, identity.language]) {
    if (isStaffLanguage(lang)) return lang
  }
  return 'en'
}
